export let CosPhiChartColors = {
  inductivo: '#105567',
  capacitivo: '#cbdc92',
};



